<script setup lang="ts">
import {LaboratoryFranco} from "@/core/interfaces/laboratory/LaboratoryFranco";
import {LaboratoryCart} from "@/laboratory/interfaces";
import {Laboratory} from "@/core/interfaces/laboratory/Laboratory";
import {computed} from "vue";
import ColorHelper from "@/core/helpers/colorHelper";

const props = defineProps<{
    franco: LaboratoryFranco;
    cart?: LaboratoryCart;
    laboratory: Laboratory
}>();


/**
 * Total cart value.
 */
const cartTotal = computed(() => {
    if (props.cart && props.franco) {
        return props.cart.lines.reduce((acc, line) => {
            return acc + (props.franco.laboratoryFrancoTypeId === 1 ? line.quantity : line.totalDiscountedWithoutVat);
        }, 0);
    }

    return null;
});

/**
 * Progress value in percentage.
 */
const progress = computed(() => {
    if (cartTotal.value && props.franco) {
        return (cartTotal.value / props.franco.francoValue > 1 ? 1 : cartTotal.value / props.franco.francoValue) * 100;
    }

    return 0;
});
</script>

<template>
  <div
    class="relative flex flex-row items-center border-2 h-8 rounded-full"
    :style="{'border-color': ColorHelper.opacity(laboratory?.branding?.primary_color, 0.1)}"
  >
    <div
      class="rounded-l-full h-full"
      :class="{'rounded-full': progress === 100}"
      :style="{'width': progress+'%', 'background-color': ColorHelper.opacity(laboratory?.branding?.primary_color, 0.1)}"
    />
    <span
      class="absolute inset-0 flex items-center justify-center text-sm font-semibold truncate"
      :style="{'color': laboratory?.branding?.primary_color}"
    >
      Franco atteint à {{ progress }}% (Besoin {{ franco.francoValue }} €)
    </span>
    <div class="bg-white" />
  </div>
</template>

<style scoped>

</style>
